export const languageConfig = [
  {
    langName: 'English',
    langCode: 'en',
    translation: 'English',
    isActive: true,
  },
  {
    langName: 'Hindi',
    langCode: 'hi',
    translation: 'हिंदी',
    isActive: true,
  },
  {
    langName: 'Assamese',
    langCode: 'sa',
    translation: 'অসমীয়া',
    isActive: true,
  },
  {
    langName: 'Bengali',
    langCode: 'bn',
    translation: 'বাংলা',
    isActive: true,
  },
  {
    langName: 'Gujarati',
    langCode: 'gu',
    translation: 'ગુજરાતી',
    isActive: true,
  },
  {
    langName: 'Urdu',
    langCode: 'ur',
    translation: 'اردو',
    isActive: true,
  },
  {
    langName: 'Punjabi',
    langCode: 'pa',
    translation: 'ਪੰਜਾਬੀ',
    isActive: true,
  },
  {
    langName: 'Kannada',
    langCode: 'kn',
    translation: 'ಕನ್ನಡ',
    isActive: true,
  },
  {
    langName: 'Malayalam',
    langCode: 'ml',
    translation: 'മലയാളം',
    isActive: true,
  },
  {
    langName: 'Marathi',
    langCode: 'mr',
    translation: 'मराठी',
    isActive: true,
  },
  {
    langName: 'Odia',
    langCode: 'ro',
    translation: 'ଓଡ଼ିଆ',
    isActive: true,
  },
  {
    langName: 'Tamil',
    langCode: 'ta',
    translation: 'தமிழ்',
    isActive: true,
  },
  {
    langName: 'Telugu',
    langCode: 'te',
    translation: 'తెలుగు',
    isActive: true,
  },
  {
    langName: 'Santhali',
    langCode: 'sn',
    translation: 'ᱥᱟᱱᱛᱟᱲᱤ',
    isActive: true,
  },
  {
    langName: 'KONKANI',
    langCode: 'ko',
    translation: 'कोंकणी',
    isActive: true,
  },
  {
    langName: 'Sindhi',
    langCode: 'si',
    translation: 'सिंधी',
    isActive: true,
  },
  {
    langName: 'Sanskrit',
    langCode: 'sk',
    translation: 'संस्कृत',
    isActive: true,
  },
  {
    langName: 'Bodo',
    langCode: 'bo',
    translation: 'बड़',
    isActive: true,
  },
  {
    langName: 'Nepali',
    langCode: 'ne',
    translation: 'नेपाली',
    isActive: true,
  },
  {
    langName: 'Manipuri',
    langCode: 'ma',
    translation: 'মণিপুরী',
    isActive: true,
  },
  {
    langName: 'Kashmiri',
    langCode: 'ka',
    translation: 'كٲشُر',
    isActive: true,
  },
  {
    langName: 'Dogri',
    langCode: 'dg',
    translation: 'डोगरी',
    isActive: true,
  },
  {
    langName: 'Maithali',
    langCode: 'mi',
    translation: 'मैथिली',
    isActive: true,
  },
];
